import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestPrecosProdutos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'precosprodutos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idproduto } = payload;

    const { data } = yield call(api.get, `precosprodutos/${idproduto}`);
    data.obsprecoproduto = '';
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { precoproduto, params } = payload;

    yield call(api.put, 'precosprodutos/insert', precoproduto);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/precosprodutos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'precosprodutos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@precoproduto/PRODUTOS_IN_REQUEST', requestPrecosProdutos),
  takeLatest('@precoproduto/SUCCESS_REMOVE', requestPrecosProdutos),
  takeLatest('@precoproduto/STORE_PRODUTO', store),
  takeLatest('@precoproduto/FIND_PRODUTO', find),
  takeLatest('@precoproduto/RECORD_FILTERING', applyedFilters),
]);
